<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="2.38419e-7 0.00000119209 18 24.3">
    <path
      d="M9.00001 18.2088L13.7729 13.5225C16.4091 10.9344 16.4091 6.73829 13.7729 4.15017C11.137 1.56206 6.86307 1.56206 4.22704 4.15017C1.59099 6.73829 1.59099 10.9344 4.22704 13.5225L9.00001 18.2088ZM15.364 15.0847L9.00001 21.3329L2.63605 15.0847C-0.878683 11.6338 -0.878683 6.03893 2.63605 2.58812C6.15077 -0.862705 11.8493 -0.862705 15.364 2.58812C18.8787 6.03893 18.8787 11.6338 15.364 15.0847ZM1.125 22.0909H16.875V24.3H1.125V22.0909Z"
    />
  </svg>
</template>
